
/* injects from baggage-loader */

import React from 'react'
import PropTypes from 'prop-types'
import {findDOMNode} from 'react-dom'
import throttle from 'lodash/throttle'

export default class ContainerDimentionsContext extends React.Component {
  static propTypes = {
    className: PropTypes.string
  }

  static childContextTypes = {
    containerWidth: PropTypes.number,
    containerHeight: PropTypes.number
  }

  constructor(props) {
    super(props)
    this.state = {
      width: null,
      height: null
    }
    this.onWindowResize = throttle(this.onWindowResize, 100)
  }

  getChildContext() {
    return {
      containerWidth: this.state.width,
      containerHeight: this.state.height
    }
  }

  componentDidMount() {
    this.node = findDOMNode(this)

    window.addEventListener('resize', this.onWindowResize)
    if (__DEV__) {
      if (this.node.clientWidth === document.body.clientWidth) {
        this.timeout = setTimeout(() => {
          this.onWindowResize()
        }, 300)
      } else {
        this.onWindowResize()
      }
    } else {
      this.onWindowResize()
    }
  }

  componentWillUnmount() {
    if (__DEV__) {
      this.timeout && clearTimeout(this.timeout)
    }
    window.removeEventListener('resize', this.onWindowResize)
  }

  render() {
    const {className} = this.props
    const {width} = this.state
    const style = {
      visibility: width ? 'visible' : 'hidden'
    }

    return <div className={className} style={style}>{this.props.children}</div>
  }

  onWindowResize = () => {
    if (!this.node) return

    this.setState({
      width: this.node.clientWidth,
      height: this.node.clientHeight
    })
  }
}



// WEBPACK FOOTER //
// ./client/components/ContainerDimentionsContext/index.js